import {DeleteOutlined, EditOutlined, FileUpload, MoreVert} from '@mui/icons-material'
import {IconButton, Menu, MenuItem, Typography} from '@mui/material'
import React, {useRef, useState} from 'react'

export type TaskMenuOption = {
  key: string
  label: string
  icon: React.ReactNode
  onClick: () => void
  dataTestId: string
  disabled?: boolean
}

type Props = {
  options: TaskMenuOption[]
}

export const TaskDeleteIcon = () => <DeleteOutlined sx={{mr: 2, verticalAlign: 'text-bottom'}} />
export const TaskEditIcon = () => <EditOutlined sx={{mr: 2, verticalAlign: 'text-bottom'}} />
export const TaskCreateMaintenanceNotificationIcon = () => (
  <FileUpload sx={{mr: 2, verticalAlign: 'text-bottom'}} />
)

export const TaskMenuActions = ({options}: Props) => {
  const menuButtonRef = useRef(null)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(anchorEl)

  const closeMenu = (e: React.MouseEvent) => {
    e.stopPropagation()
    setAnchorEl(null)
  }

  const openMenu = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }

  if (!options.length) {
    return null
  }

  return (
    <>
      <IconButton
        sx={{p: 1}}
        ref={menuButtonRef}
        onClick={openMenu}
        color="primary"
        data-test-id="task-details-more-button"
      >
        <MoreVert color="primary" />
      </IconButton>
      <Menu
        data-test-id="task-details-more-menu"
        anchorEl={menuButtonRef.current}
        open={isMenuOpen}
        onClose={closeMenu}
      >
        {options.map(({onClick, dataTestId, key, icon, label, disabled}) => (
          <MenuItem
            onClick={() => {
              setAnchorEl(null)
              onClick()
            }}
            data-test-id={dataTestId}
            key={key}
            disabled={disabled}
          >
            {' '}
            <Typography variant="subtitle1">
              {icon}
              {label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
